export const sets = [
  {
    code: 'eld',
    name: 'Throne of Eldraine',
    path: '/articles/cube-prospective-throne-of-eldraine/',
  },
  {
    code: 'thb',
    name: 'Theros: Beyond Death',
    path: '/articles/cube-prospective-theros-beyond-death/',
  },
  {
    code: 'iko',
    name: 'Ikoria: Lair of Behemoths',
    path: '/articles/cube-prospective-ikoria-lair-of-behemoths/',
  },
  {
    code: 'c20',
    name: 'Commander 2020',
    path: '/articles/cube-prospective-commander-2020/',
  },
  {
    code: 'm21',
    name: 'Core Set 2021',
    path: '/articles/cube-prospective-core-set-2021/',
  },
  {
    code: 'jmp',
    name: 'Jumpstart',
    path: '/articles/cube-prospective-jumpstart/',
  },
]
